import React, { useState } from 'react'
import _ from "lodash";
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { useGlobalContext } from '../../../GlobalContext'
import { deleteCompanyUser } from '../../../../actions/company'
import { getLunchReceipt } from '../../../../actions/payment'
import ReactTooltip from 'react-tooltip';


import IconPencilWhite from '../../../../assets/images/icons/icon-pencil-white.svg'
import IconPencilHover from '../../../../assets/images/icons/icon-pencil-hover.svg'
import DustBinIcon from '../../../../assets/images/icons/dustbin_icon.svg'
import DustBinIconWhite from '../../../../assets/images/icons/dustbin_icon-white.svg'
import DustBinIconHover from '../../../../assets/images/icons/dustbin_icon_hover.svg'
import LunchIcon from '../../../../assets/images/icons/lunch.svg'

import FormContributors from './FormContributors'

import styles from './contributors.module.scss';

export default function LineUser({user, isLoading, edit, selectUser, selectedUser, cancel, lunchPaymentReadyEmail, lunchPaymentPaidDays}){
  const [context, dispatch] = useGlobalContext();
  const companyReducer = context.companyReducer
  const [isReceiptLoading, setIsReceiptLoading] = useState(false);


  //ACTIONS
  const _deleteCompanyUser = (id) => deleteCompanyUser(dispatch,id)

  function normalizeDateKey(value) {
    if (value === null || value === undefined || value === '' || value === 'cocktail') {
      return null;
    }
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) {
      return String(value);
    }
    return date.toISOString().slice(0, 10);
  }

  function listIncludesDate(list, date) {
    const key = normalizeDateKey(date);
    if (!key || !Array.isArray(list)) return false;
    return list.some((item) => normalizeDateKey(item) === key);
  }

  function renderPresenceDays(days = []){
    if(!companyReducer.companyList) return;
    let arr = []

    let found = companyReducer.companyList.days.filter(opt=>{
      return days.includes(opt.value)
    })

    if(found){
      arr = found.map(d => d.label)
    }

    const paidDays = user.lunchPaidDays || [];
    const lunchDays = user.lunchDays || (user.lunch ? user.presence : []);

    const getDateStr = (date) => {
      const day = format(new Date(date), 'd MMMM', { locale: fr });
      return day;
    }

    return (
      <ul >
        <li className="only-on-tablet"><label>Présence sur le salon :</label></li>
        {companyReducer.companyList.days.map((d, i) => {
          const isPresent = _.includes(arr,d.label);
          const hasLunch = listIncludesDate(lunchDays, d.value);
          const lunchPaid = listIncludesDate(paidDays, d.value) || (user.lunchPaid && hasLunch && (!user.lunchPaidDays || !user.lunchPaidDays.length));
          return (
            <li key={'day-'+i} className={isPresent ? styles.day : `${styles.day} ${styles.disabled}`}>
              <p>
                <span>{getDateStr(d.value)}</span>
                {isPresent && hasLunch && lunchPaid &&
                  <img
                    src={LunchIcon}
                    className={styles['lunch-paid-badge']}
                    title="Déjeuner payé"
                    alt="Déjeuner payé"
                  />
                }
              </p>
            </li>
          )
        })}
      </ul>
    )
  }

  function deleteUser(){
    const isConfirm = window.confirm("Attention, cette action supprimera l’utilisateur. Si il est déclaré comme “autre contact” de votre société, il ne recevra plus de mail. Voulez-vous continuer ?");
    if(isConfirm === true){
      _deleteCompanyUser(user._id)
    }
  }

  function toggleFormContact(){
    if(edit){
      cancel()
    }else{
      selectUser(user._id)
    }
  }

  async function openLunchReceipt(event) {
    event.stopPropagation();
    if (isReceiptLoading) return;

    setIsReceiptLoading(true);
    try {
      const response = await getLunchReceipt(dispatch, user._id);
      if (response?.url) {
        window.open(response.url, '_blank', 'noopener,noreferrer');
      }
    } finally {
      setIsReceiptLoading(false);
    }
  }

  function getClassName(){
    if(selectedUser && selectedUser !== user._id){
      return `${styles['line-user']} ${styles['fade-out']}`
    }else{
      return isLoading && isLoading.action === "delete" ? `${styles['line-user']} ${styles.loading}` : styles['line-user']
    }
  }

  return (
    <>
    {!edit &&
      <div className={getClassName()}>
        <div className={`${styles.container} container hide-on-mobile`}>
          <div><p className={styles.name}>{user.profile.firstName} {user.profile.lastName}</p></div>
          <div><p>{user.profile.function}</p></div>
          <div><p>{user.email.split("//")[0]}</p></div>
        </div>
        <div className={styles['line-actions']}>
          <div className={styles['presence-days']}>{renderPresenceDays(user.presence)}</div>
          <div className={styles.edit}>
            <div className={`${styles.user} only-on-mobile`}>
              <div><p className={styles.name}>{user.profile.firstName} {user.profile.lastName}</p></div>
              <div><p>{user.profile.function}</p></div>
              <div><p>{user.email.split("//")[0]}</p></div>
            </div>
            {(user.lunchPaid || (user.lunchPaidDays && user.lunchPaidDays.length > 0)) &&
              <div className={styles['lunch-receipt-wrap']}>
                <a
                  className={styles['lunch-receipt']}
                  onClick={openLunchReceipt}
                  disabled={isReceiptLoading}
                  data-tip="Télécharger la facture du déjeuner"
                  aria-label="Télécharger la facture du déjeuner"
                >
                  {isReceiptLoading ? '...' : 'Facture repas'}
                </a>
              </div>
            }
            <div className={styles['toggle-edit']}>
              <button
                type="button"
                className={styles['toggle-edit-icon']}
                onClick={toggleFormContact}
                aria-label={`modifier ${user.profile.firstName} ${user.profile.lastName}`}
              >
                <img src={IconPencilHover} className="hide-on-mobile" alt="" />
                <img className="only-on-mobile" src={IconPencilWhite} alt="" />
              </button>
            </div>
            { user.role !== "Owner" &&
              <div className={styles.delete} onClick={deleteUser}>
                <img className="hide-on-mobile" src={DustBinIcon} data-tip="Supprimer" alt={"supprimer "+user.profile.firstName+" "+user.profile.lastName} />
                <img className="hide-on-mobile" src={DustBinIconHover} data-tip="Supprimer" alt={"supprimer "+user.profile.firstName+" "+user.profile.lastName} />
                <img className="only-on-mobile" src={DustBinIconWhite} alt={"supprimer "+user.profile.firstName+" "+user.profile.lastName} />
              </div>
            }
          </div>
        </div>
        { isLoading && isLoading.action === "update" ?
          <div className={styles.loader}></div> :
          null
        }

      </div>
    }
    {edit &&
      <FormContributors
        key={"update_"+user._id}
        isLoading={isLoading}
        user={user}
        cancel={cancel}
        lunchPaymentReadyEmail={lunchPaymentReadyEmail}
        lunchPaymentPaidDays={lunchPaymentPaidDays}
      />
    }
      <ReactTooltip globalEventOff="click" effect="solid" className="custom-tooltip hide-on-tablet" backgroundColor="#005FBF"/>
    </>
  )
}
